"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ThingTypesInCategoryTitle = ThingTypesInCategoryTitle;
exports.ThingTypesInCategoryTemplatePath = ThingTypesInCategoryTemplatePath;
exports.ThingTypePath = ThingTypePath;
exports.thingTypesInCategoryTemplateRoute = thingTypesInCategoryTemplateRoute;
exports.thingTypesInCategoryTemplateRoutes = thingTypesInCategoryTemplateRoutes;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createRoute = require("../../../../../../react-static/route/createRoute");

var _getPath = require("../../../../../../react-static/route/getPath");

var _Category = require("../Category");

var _slugify = require("../../../../../../html/slugify");

var _fetchThingTypesInCategory = require("./fetchThingTypesInCategory");

var _ItemType = require("../../item-type/ItemType"); // noinspection ES6UnusedImports


function ThingTypesInCategoryTitle(categoryName) {
  return categoryName + " Packing List Items & Tips";
}

function ThingTypesInCategoryTemplatePath(categorySlug) {
  return (0, _getPath.getPath)(categorySlug, _Category.PackingCategoryPath);
}

function ThingTypePath(thingTypeSlug) {
  return (0, _getPath.getPath)(_ItemType.ItemTypePath, thingTypeSlug);
}

function thingTypesInCategoryTemplateRoute(rootPath, category, thingTypesInCategory) {
  var thingTypes = thingTypesInCategory.allThingTypes.edges.map(function (thingTypeEdge) {
    var thingType = thingTypeEdge.node;
    var url = null; // Not all Thing Types have URLs.
    // If URL exists, it can be from root or a slug appended to default Item Type path

    if (thingType.url) {
      url = thingType.url.startsWith("/") ? thingType.url : (0, _ItemType.ItemTypeItemPath)(thingType.url);
    } // TODO toNumberString function with radix or something


    return {
      id: thingType.id.toString(),
      name: thingType.name,
      url: url,
      brief: thingType.brief
    };
  });
  var tips = thingTypesInCategory.allTips.edges.map(function (tipEdge) {
    var tip = tipEdge.node;
    var thingTypeName;

    if (tip.thingTypeId) {
      thingTypeName = tip.thingTypeByThingTypeId.name;
      var thingTypePath = null;
      var thingTypeUrl = tip.thingTypeByThingTypeId.url;

      if (thingTypeUrl) {
        var thingTypeSlug = (0, _slugify.slugify)(thingTypeName);
        thingTypePath = ThingTypePath(thingTypeSlug);
      }
    }

    return {
      id: tip.id,
      title: tip.title,
      thingTypeName: thingTypeName,
      description: tip.description,
      thingTypePath: thingTypePath
    };
  });
  var categorySlug = (0, _slugify.slugify)(category.name);
  var title = ThingTypesInCategoryTitle(category.name);
  var categoryDescription = category.description;
  var path = ThingTypesInCategoryTemplatePath(categorySlug);
  var route = (0, _createRoute.createRoute)(rootPath, path);
  route.component = rootPath + _Category.PackingCategoryPath + "thingTypesInCategoryTemplate";

  route.getData = function () {
    return {
      path: path,
      title: title,
      categoryDescription: categoryDescription,
      thingTypes: thingTypes,
      tips: tips
    };
  };

  return route;
}

function thingTypesInCategoryTemplateRoutes(_x, _x2) {
  return _thingTypesInCategoryTemplateRoutes.apply(this, arguments);
}

function _thingTypesInCategoryTemplateRoutes() {
  _thingTypesInCategoryTemplateRoutes = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(rootPath, packingCategories) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all(packingCategories.edges.map(
            /*#__PURE__*/
            function () {
              var _ref = (0, _asyncToGenerator2.default)(
              /*#__PURE__*/
              _regenerator.default.mark(function _callee(categoryEdge) {
                var category, thingTypesInCategory;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        category = categoryEdge.node;
                        _context.next = 3;
                        return (0, _fetchThingTypesInCategory.fetchThingTypesInCategory)(category.id);

                      case 3:
                        thingTypesInCategory = _context.sent;
                        return _context.abrupt("return", thingTypesInCategoryTemplateRoute(rootPath, category, thingTypesInCategory));

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }()));

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _thingTypesInCategoryTemplateRoutes.apply(this, arguments);
}